import eventNames from "./eventNames";

const handlersTasks = new Map<string, Map<string, any>>([
    [eventNames.refreshWards, new Map<string, any>()],
    [eventNames.refreshCustomers, new Map<string, any>()],
    [eventNames.refreshLocations, new Map<string, any>()],
    [eventNames.refreshUsers, new Map<string, any>()],
    [eventNames.newTransfer, new Map<string, any>()],
    [eventNames.transferUpdated, new Map<string, any>()],
    [eventNames.transferScheduleUpdated, new Map<string, any>()],
    [eventNames.logoutUserActiveSessions, new Map<string, any>()],
    [eventNames.refreshCallouts, new Map<string, any>()],
    [eventNames.newTeammember, new Map<string, any>()]
  ]);

const addTaskForEvent = (eventName: string, taskId: string, task: any) =>{
    const mapOfTasks = handlersTasks.get(eventName);
    mapOfTasks?.set(taskId,task);
}

const removeTaskForEvent = (eventName: string, taskId: string) =>{
    const mapOfTasks = handlersTasks.get(eventName);
    mapOfTasks?.delete(taskId);
}

const getTasksForEvent = (eventName: string): any[] =>{
     const mapOfTasks = handlersTasks.get(eventName);
     return mapOfTasks &&  mapOfTasks.size > 0 ? [...mapOfTasks.values()] : [];
}

export {
    addTaskForEvent,
    removeTaskForEvent,
    getTasksForEvent
}